import "@hotwired/turbo-rails"
import "@hotwired/hotwire-native-bridge"
import "./controllers"

// Disable prefetch-on-hover — prevents spurious server hits when mousing over nav links
Turbo.config.drive.prefetchCacheSize = 0
